import { render, staticRenderFns } from "./aiCustomPageFormConfig.vue?vue&type=template&id=3ac7cddf&scoped=true&"
import script from "./aiCustomPageFormConfig.vue?vue&type=script&lang=js&"
export * from "./aiCustomPageFormConfig.vue?vue&type=script&lang=js&"
import style0 from "./aiCustomPageFormConfig.vue?vue&type=style&index=0&id=3ac7cddf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac7cddf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ac7cddf')) {
      api.createRecord('3ac7cddf', component.options)
    } else {
      api.reload('3ac7cddf', component.options)
    }
    module.hot.accept("./aiCustomPageFormConfig.vue?vue&type=template&id=3ac7cddf&scoped=true&", function () {
      api.rerender('3ac7cddf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/aiCustomPage/aiCustomPageFormConfig.vue"
export default component.exports